import { Controller } from '@hotwired/stimulus'

// Handles Select2 initialization for student multi-select fields.
// Expects a <select> element with data-student-select-target="input".
// The select must include data-maximum-selection-length and data-placeholder attributes.

export default class extends Controller {
  static targets = ['input']

  connect() {
    const $select = $(this.inputTarget)
    const $modal = $select.closest('.modal')

    if ($modal.length) {
      $modal.one('shown.bs.modal', () => this.initializeSelect2($select))
    } else {
      this.initializeSelect2($select)
    }
  }

  initializeSelect2($select) {
    if (!$select || !$select.length) {
      return
    }

    if (typeof $ === 'undefined' || !$.fn.select2) {
      console.error('jQuery or Select2 not available')
      return
    }

    const maxSelectionLength = Number($select.data('maximum-selection-length') || 10)
    const placeholder = $select.data('placeholder') || 'Select students'

    if ($select.hasClass('select2-hidden-accessible')) {
      $select.select2('destroy')
    }

    console.log('Initializing Select2 with maxSelectionLength:', maxSelectionLength, 'and placeholder:', placeholder)

    $select.select2({
      placeholder,
      width: '100%',
      maximumSelectionLength: maxSelectionLength,
      dropdownParent: $select.closest('.modal').length ? $select.closest('.modal') : $(document.body)
    })
  }

  disconnect() {
    if ($(this.inputTarget).hasClass('select2-hidden-accessible')) {
      $(this.inputTarget).select2('destroy')
    }
  }
}
